module.exports = __webpack_public_path__ + "img/wisa_mobile_02.429067a8.png";